exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MixBlend__normal___1LjN_ {\n  mix-blend-mode: normal; }\n\n.MixBlend__multiply___3YK6K {\n  mix-blend-mode: multiply; }\n", ""]);

// exports
exports.locals = {
	"normal": "MixBlend__normal___1LjN_",
	"multiply": "MixBlend__multiply___3YK6K"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/styles/MixBlend.scss
// module id = 174
// module chunks = 0